var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2829",
  d: "M12 7.003a1 1 0 01.707.293l8 8a1 1 0 01-1.414 1.414L12 9.417 4.708 16.71a1 1 0 11-1.414-1.414l8-8A1 1 0 0112 7.003z",
  fill: "#f96506"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 144545",
  fill: "none",
  d: "M0 0h24v24H0z"
})));
export default __webpack_public_path__ + "static/icon-chevron-up.e4b0dba5291e6b4f3ba77d71dc3a8133.svg";
export { SvgIconChevronUp as ReactComponent };